<template>
  <div>
    <el-transfer
      :data="stuff"
      :props="{ key: 'stuffCd', label: 'stuffNmLan' }"
      v-model="inputForm.stuffsCds"
      :titles="[listTitle, dataTitle]"
      :button-texts="[listBtn, dataBtn]">
      <span slot-scope="obj"
        >{{ obj.option.stuffNmLan
        }}{{ util.isEmpty(obj.option.stuffNation) ? '' : '(' + obj.option.stuffNationNm + ')' }}</span
      >
    </el-transfer>
  </div>
</template>

<script>
export default {
  props: ['value', 'stuff'],
  data() {
    const data = {}

    data.listTitle = this.$t('재료 리스트')
    data.dataTitle = this.$t('재료')
    data.listBtn = this.$t('제거')
    data.dataBtn = this.$t('설정')

    return data
  },
  computed: {
    inputForm: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('update', value)
      },
    },
  },
}
</script>

<style scoped>
.el-transfer {
  position: relative;

  display: flex;
  align-items: center;

  gap: 10px;

  width: 100%;
  max-width: 1000px;

  padding-top: 50px;
}
.el-transfer::v-deep .el-transfer-panel {
  flex-grow: 1;
}

@media (max-width: 768px) {
  .el-transfer {
    flex-direction: column;

    padding-top: 0;
  }
  .el-transfer::v-deep .el-transfer-panel {
    width: 100%;
  }
  .el-transfer::v-deep .el-transfer__button:first-child {
    margin-bottom: 0px;
  }
}
/**
::v-deep .el-transfer__buttons {
  position: absolute;
  top: 0;
  right: 0;

  padding: 0;
}
 */
</style>
